document.addEventListener('DOMContentLoaded', function(dom) {
  const navbar = dom.target.getElementById('js-navbar')
  const menuNavbar = dom.target.getElementById('js-menu-navbar')

  const offcanvasMenu = dom.target.getElementById('offcanvasMenu');

  offcanvasMenu.addEventListener('shown.bs.offcanvas', () => {
    navbar.classList.add('hidden')
    menuNavbar.classList.remove('hidden')
  });

  offcanvasMenu.addEventListener('hide.bs.offcanvas', () => {
    navbar.classList.remove('hidden');
    menuNavbar.classList.add('hidden');
  });
})
